import React from "react";
import { baseURL } from "../Config/config";

function Cadence() {

  React.useEffect(() => {
    sessionStorage.setItem(
      "cadence_api_base",
      baseURL
    );
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <iframe
        src="/Cadence/index.html"
        title="CADENCE"
        style={{
          border: "none",
          width: "100%",
          height: "100vh",
          display: "block",
        }}
      />
    </div>
  );
}

export default Cadence;